import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BuildingType } from '../../data';

@Component({
    selector: '[app-space-config-roof]',
    templateUrl: './space-config-roof.component.html',
    styleUrl: './space-config-roof.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SpaceConfigRoofComponent {
  type = input<BuildingType>();
}
